const allLanguages = localStorage.allLanguages ? JSON.parse(localStorage.allLanguages) : {};
//翻译方法
// function translate() {
//   let lng = localStorage.lang ? localStorage.lang : 'en-US';
//   return allLanguages[lng] || {};
// }
// const languages = translate();

function ml(id, showNull) {
  let language = '';
  if (!showNull) {
    language = id;
  }
  if (allLanguages[id]) {
    language = allLanguages[id];
  }
  return language;
}
export { allLanguages, ml };
